export const clamp = (value, max) => Math.max(Math.min(value, max), 0);
